module.exports = __webpack_public_path__ + "img/icon-clear.b35ba19a.svg";